import axios from 'axios';
import ServerProperties from '../../config/server.js'

export default {
  Read: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
      ServerProperties.ATM_CLOUD.API + 'Tenant/?page=' + params.data.page + '&' + params.data.order + '&' + params.data.filter
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
      params.onfailed(error)
    });
  },
  Register: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.post(ServerProperties.ATM_CLOUD.API + 'Tenant/Create/', {
      ...params.data.field
    })
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
      params.onfailed(error)
    });
  },
  Update: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(ServerProperties.ATM_CLOUD.API + 'Tenant/Update/' + params.data.id + '/', {
      ...params.data.field
    })
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
      params.onfailed(error)
    });
  },
  Detail: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(ServerProperties.ATM_CLOUD.API + 'Tenant/Detail/' + params.data.id + '/')
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
      params.onfailed(error)
    });
  },
  UserList: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(params.data.url === undefined ? 
      ServerProperties.ATM_CLOUD.API + 'Tenant/Users/' + params.data.id + '/' : params.data.url
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
      params.onfailed(params, error)
    });
  },
}


// WEBPACK FOOTER //
// ./src/App/tenant/tenant/model.js